import { createFeatureSelector, createSelector } from '@ngrx/store';

import { InsurancePackagesState } from './insurance-packages.reducer';

export const selectPackagesState = createFeatureSelector<InsurancePackagesState>('insurance-packages');

export const insurancePackages = createSelector(selectPackagesState, (state: InsurancePackagesState) => state.insurancePackages);
